import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  height: "48",
  width: "48",
  class: "yb-svg-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", null, [
      _createElementVNode("path", {
        d: "M20.07,6.54a.25.25,0,0,0,.27,0,.23.23,0,0,0,.16-.23V1.49A.5.5,0,0,0,20,1H16.5a.5.5,0,0,0-.5.5v.59a.52.52,0,0,0,.14.35Z",
        fill: "currentColor"
      }),
      _createElementVNode("path", {
        d: "M23.72,11.8,12.72.3a1,1,0,0,0-1.44,0L.28,11.8a1,1,0,0,0-.2,1.09,1,1,0,0,0,.92.6H2.5A.5.5,0,0,1,3,14v8.5A1.5,1.5,0,0,0,4.5,24H9a1,1,0,0,0,1-1V19a2,2,0,0,1,4,0v4a1,1,0,0,0,1,1h4.5a1.5,1.5,0,0,0,1.5-1.5V14a.5.5,0,0,1,.5-.5H23a1,1,0,0,0,.92-.6A1,1,0,0,0,23.72,11.8Z",
        fill: "currentColor"
      })
    ], -1)
  ])))
}
export default { render: render }